export class FeedbackProps {
    started: boolean;
    actionSucceeded: boolean;
    errors: any;
    errorDescription: string;
    successMessage: string;
}



// WEBPACK FOOTER //
// ./src/app/shared/interfaces/feedback-props.interface.ts